type ScrollHandlerOptions = {
  threshold?: number;  // triggered at 80% of the total view height
  isLoading: boolean; // condition of the REQUEST_LOADING_STATES
  hasLoadedMore: boolean; // condition to keep track if it's the first time we load data, we can change it to number of pages
  hasMore: boolean; // condition if there's more data to load
  onLoadMore: () => void; // callback that loads more data
  onSetLoadedMore: (value: boolean) => void; // change the state when we load more
  onSetIsPage?: (value: boolean) => void;//optional but mandatory at publication swiper
};

export const createScrollHandler = ({
  threshold = 0.8,
  isLoading,
  hasLoadedMore,
  hasMore,
  onLoadMore,
  onSetLoadedMore,
  onSetIsPage,
}: ScrollHandlerOptions) => {
  return (e: React.UIEvent<HTMLElement, UIEvent>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    const scrolled = (scrollTop + clientHeight) / scrollHeight;

    if (scrolled >= threshold &&  isLoading && !hasLoadedMore && hasMore) {
      onSetLoadedMore(true);
      if (onSetIsPage) onSetIsPage(true);
      onLoadMore();
    }
  };
};
